exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "iframe[_v-350b5330]{width:100%;height:400px}.col-sm-3[_v-350b5330],.col-sm-8[_v-350b5330],.form-horizontal[_v-350b5330]{padding:0}textarea[_v-350b5330]{margin-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-350b5330&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Contact.vue
// module id = 420
// module chunks = 0